export const environment = {
    production: true,
    //API_URL:'https://mis-central-stag.moveinsync.com/centralized-dashboard'
    STAGE_URL : 'https://mis-central-dashboard.moveinsync.com',
    API_URL: 'https://centraldashboard-beta.moveinsync.com/centralized-dashboard',
    CONFIGURATION_SERVICE_API :'https://mis-central-dashboard.moveinsync.com/centralized-dashboard/config-green',
    VET_URL:"https://fleet-delta.moveinsync.com/fis/trip-view",
    VET_CONFIG_URL:"https://fleet-delta.moveinsync.com/fis/trip-view/config-green",
    ANALYTICS_KEY : 'G-X74BQWTS6E',
    assetPath: '../../tripview/',
    replayAssetPath: '../../tripview/', 
    sentry:'https://3b6eb65d0975a17d0fddcdea33bee7c2@o4507695693234176.ingest.de.sentry.io/4509089447936080',
    tag:"prod-beta",
   troubleShootingApiUrl: 'https://troubleshooting.moveinsync.com'
  };
  